<template>
    <div class="d-flex">
        <responsive-button @click="onEdit" class="mr-1" variant="default" :icon="['fas', 'edit']">
            Edit
        </responsive-button>
        <responsive-button v-if="params.onDelete" @click="$bvModal.show(deleteModalId)" variant="default"
            :icon="['fas', 'trash']">
            Delete
        </responsive-button>
        <modal :id="deleteModalId" title="Warning" @ok.prevent="onDelete">
            {{ params.deleteMessage }}
        </modal>
    </div>
</template>

<script>
import responsiveButton from '../../generic/responsive-button/responsive-button.vue';
import modal from '../../generic/modal/modal.vue';
export default {
    name: 'EditDeleteActionCellRenderer',
    components: {
        responsiveButton,
        modal
    },
    methods: {
        onEdit() {
            this.params.onEdit(this.params.data)
        },
        onDelete() {
            this.params.onDelete(this.params.data)
        }
    },
    computed: {
        deleteModalId() {
            return 'delete-modal-' + this.params.data.id;
        }
    }
}
</script>

<style scoped>
/* Your CSS code here */
</style>
